import { inject, Injectable, Injector } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { from, Observable } from 'rxjs';
import {
  IdentifierPoolsBulkImportModalComponent
} from './identifier-pools-bulk-import-modal/identifier-pools-bulk-import-modal.component';
import {
  IdentifierPoolsAddEditPoolModalComponent
} from "./identifier-pools-add-edit-pool-modal/identifier-pools-add-edit-pool-modal.component";
import { IdentifierPool } from "./identifier-pools-model";
import { createModalInjector } from "../../utils/create-modal-injector";
import {
  IdentifierPoolsProductModalComponent
} from "./identifier-pools-product-modal/identifier-pools-product-modal.component";

@Injectable({
  providedIn: 'root'
})
export class IdentifierPoolsModalService {
  private readonly ngbModal = inject(NgbModal);
  private injector = inject(Injector);

  openBulkImportModal(pool?: IdentifierPool, parseOnly: boolean = false): Observable<any> {
    const modalRef = this.ngbModal.open(IdentifierPoolsBulkImportModalComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
      injector: createModalInjector({
        pool,
        parseOnly
      }, this.injector)
    });

    return from(modalRef.result);
  }

  openAddOrEditPoolModal(data?: IdentifierPool): Observable<any> {
    const modalRef = this.ngbModal.open(IdentifierPoolsAddEditPoolModalComponent, {
      size: 'xl',
      backdrop: 'static',
      centered: true,
      injector: createModalInjector(data, this.injector)
    });

    return from(modalRef.result);
  }

  openProductIdModal(): Observable<string | undefined> {
    const modalRef = this.ngbModal.open(IdentifierPoolsProductModalComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      injector: createModalInjector({}, this.injector)
    });

    return from(modalRef.result);
  }
}
